import React from 'react';
import addModifiers from 'utils/add_modifiers';

const SaveButton = ({ loading, label, onClick, ...props }) => (
  <button
    type="button"
    className={`ml-16 ${addModifiers('NewButton', ['blue', 'wide', 'center'])}`}
    onClick={!loading ? onClick : null}
  >
    {loading && <span className="Spinner mr-4" />}
    {label}
  </button>
);

SaveButton.defaultProps = {
  label: 'Save',
};

export default SaveButton;
